import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 211  -  除此之外的场合
 */

export default class EventIfChoice extends EventBase {
  /**
   * 除此之外的场合的构造函数
   */
  constructor() {
    super()
    this.Parameter = ['']
  }

  /**
   * 事件ID
   */
  Code = EventID.IfChoice

  /**
   * 获得该事件在事件列表的描述信息
   */
  /// <returns>事件描述信息</returns>
}
